module.exports = __webpack_public_path__ + "img/full4-min.a6c7e5c0.png";